import axiosInstance from "../config/axios";
import API_ENDPOINTS from "../config/endpoints";

export const getBlogs = async () => {
  try {
    const response = await axiosInstance.get(API_ENDPOINTS.GET_BLOGS);
    return response; // expecting array of blogs
  } catch (error) {
    throw error;
  }
};

export const getBlogById = async (id) => {
  try {
    const response = await axiosInstance.get(API_ENDPOINTS.GET_BLOG_BY_ID(id));
    return response; // expecting single blog with BlogDescs
  } catch (error) {
    throw error;
  }
};


